import React, { useState } from "react";
import { useController, Controller } from "react-hook-form";
import InputMask from 'react-input-mask';
import _ from "lodash";

/* eslint-disable */
export const Mask = React.forwardRef((props, ref) => {
  const { field, fieldState } = useController(props);
  const [focusState, setFocusState] = useState(false);
  const { title, style, errors, defaultValue, showLableInline, ellipses, isHighLight, customStyle, onChange, mask="99/99/9999", isDisabled=false,...others } = props;
  let err = _.get(errors, props.name)
  return (

    <div className="w-full">
        {!showLableInline &&
            <label className={`text-start block text-sm font-medium leading-6 ${props?.rules && err ? "text-red-600" : "text-gray-900"}`}>
                {title} {props?.rules?.required?.value === true && <span className="text-red-500 mt-10">*</span>}
            </label>
        }
        <div className={`${customStyle ? customStyle : ''} relative bg-white focus-within:bg-white outlineStyle rounded ${props?.rules && err ? "focus-within:border-red-600 border-red-600" : ""}`}>
            <Controller
            name={props?.name}
            control={props?.control}
            rules={props?.rules}
            defaultValue={defaultValue}
            render={({ field: { ref } }) => (
                <InputMask 
                    {...props}
                    {...field}
                    ref={(elem) => {
                        elem && ref(elem.input);
                    }}
                    mask={mask}
                    onBlurCapture={() => {
                        field.onBlur;
                        setFocusState(false)}
                    }
                    autoComplete="off"
                    onFocus={() => setFocusState(true)}
                    onChange={e => {
                        field.onChange(e);
                        if (props.onChange) {
                            props.onChange(e, props?.name);
                        }
                    }}
                    disabled={isDisabled ?isDisabled :false}
                    placeholder={props.placeholder ? props.placeholder : ''}
                    value={field.value}
                    className={`${isDisabled && "bg-gray-50 cursor-not-allowed"} block w-full rounded-md px-1 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-gray-600 sm:text-sm sm:leading-6`} {...others}
                />
            )}
            />

            {showLableInline &&
                <div
                    className={`pointer-events-none absolute ml-2 left-0 duration-300 origin-0 mr-2 inline-block px-1 font-normal  ${props?.rules && err ? "text-red-600" : "text-gray-600"}  ${focusState || !field.value == "" || field.value == "0"
                        ? "-top-2 duration-300 bg-[white] text-xs rounded-lg"
                        : `top-2 duration-300 text-base xl:top-1 ${ellipses && 'w-[98%] text-ellipsis overflow-hidden whitespace-nowrap'}`}
                        ${isHighLight && " bg-highLight  "}  
                    `}
                >
                    {title} {props?.rules?.required?.value === true && <span className="text-red-500 mt-10">*</span>}
                </div>
            }
        </div>
        {props.rules && err &&
            <p className=" text-xs text-red-600 h-3 text-left text-start" id="email-error">
                {props.rules && err && (
                props.rules && err?.message
                )}
            </p>
        }
    </div>
  );
});